import { Platform, StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export const getLeagueStandingsTableStyles = (theme: Theme, windowWidth = 390) => {
  const comfortable = windowWidth >= 768
  const spacious = windowWidth >= 1024

  const tablePadH = spacious ? 12 : comfortable ? 8 : 6
  const headerLabelFs = spacious ? 10 : 9
  const rankFs = spacious ? 14 : comfortable ? 13 : 12
  const teamFs = spacious ? 13 : comfortable ? 12 : 12
  const cellFs = spacious ? 12 : comfortable ? 11 : 11
  const ptsFs = spacious ? 14 : comfortable ? 13 : 12
  const cardRadius = spacious ? 28 : comfortable ? 27 : 26
  const rowPadV = spacious ? 12 : comfortable ? 11 : 10

  return StyleSheet.create({
    tableCardWrap: {
      width: '100%',
    },
    tableCard: {
      width: '100%',
      alignSelf: 'stretch',
      backgroundColor: theme.background.card,
      borderRadius: cardRadius,
      borderWidth: 1,
      borderColor: theme.gray[200],
      paddingTop: spacious ? 14 : comfortable ? 13 : 12,
      paddingBottom: spacious ? 10 : comfortable ? 9 : 8,
      overflow: 'hidden',
      ...(Platform.OS === 'web'
        ? { boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)' as const }
        : {
            shadowColor: theme.black,
            shadowOffset: { width: 0, height: 6 },
            shadowOpacity: 0.08,
            shadowRadius: 16,
            elevation: 6,
          }),
    },
    headerRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: tablePadH,
      paddingBottom: spacious ? 10 : comfortable ? 9 : 8,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
    },
    headerRowPadStart: {
      width: 10,
      flexShrink: 0,
    },
    headerCellRank: {
      width: spacious ? 24 : 22,
      flexShrink: 0,
      alignItems: 'flex-start',
    },
    headerTeamKitSpacer: {
      width: spacious ? 30 : comfortable ? 28 : 27,
      flexShrink: 0,
    },
    headerCellTeam: {
      flex: spacious ? 4.6 : comfortable ? 4.7 : 4.8,
      minWidth: 0,
      flexDirection: 'row',
      alignItems: 'center',
      paddingRight: spacious ? 8 : comfortable ? 6 : 4,
    },
    headerCellTeamForm: {
      flex: 1,
      minWidth: 0,
      flexDirection: 'row',
      alignItems: 'center',
      paddingRight: spacious ? 8 : comfortable ? 6 : 4,
    },
    tableSymCell: {
      flex: 1,
      minWidth: spacious ? 24 : 20,
      alignItems: 'flex-start',
      justifyContent: 'center',
    },
    tableSymCellPts: {
      flex: 1,
      minWidth: spacious ? 24 : 20,
      alignItems: 'flex-end',
      justifyContent: 'center',
    },
    headerCellFormFixed: {
      width: spacious ? 108 : comfortable ? 102 : 96,
      flexShrink: 0,
      alignItems: 'center',
      justifyContent: 'center',
    },
    headerCellPtsForm: {
      width: spacious ? 44 : 40,
      flexShrink: 0,
      alignItems: 'flex-end',
      justifyContent: 'center',
    },
    headerText: {
      fontSize: headerLabelFs,
      fontWeight: '700',
      color: theme.gray[500],
      letterSpacing: 0.3,
      textTransform: 'uppercase',
      textAlign: 'center',
    },
    headerStatLabel: {
      fontSize: headerLabelFs,
      fontWeight: '700',
      color: theme.gray[500],
      letterSpacing: 0.3,
      textTransform: 'uppercase',
      textAlign: 'left',
      width: '100%',
    },
    headerStatLabelEnd: {
      fontSize: headerLabelFs,
      fontWeight: '700',
      color: theme.gray[500],
      letterSpacing: 0.3,
      textTransform: 'uppercase',
      textAlign: 'right',
      width: '100%',
    },
    headerStatSym: {
      fontSize: headerLabelFs,
      fontWeight: '700',
      color: theme.gray[500],
      letterSpacing: 0.3,
      textTransform: 'uppercase',
      textAlign: 'left',
      width: '100%',
    },
    headerTextTeam: {
      flex: 1,
      minWidth: 0,
      fontSize: headerLabelFs,
      fontWeight: '700',
      color: theme.gray[500],
      letterSpacing: 0.3,
      textTransform: 'uppercase',
      textAlign: 'left',
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: rowPadV,
      paddingHorizontal: tablePadH,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[100],
    },
    rowForm: {
      alignItems: 'center',
    },
    rowLast: {
      borderBottomWidth: 0,
    },
    rowLeading: {
      width: 5,
      flexShrink: 0,
      alignSelf: 'stretch',
      marginRight: 5,
      marginVertical: -rowPadV,
      marginLeft: -tablePadH,
      borderTopRightRadius: 3,
      borderBottomRightRadius: 3,
    },
    rowInner: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
      minWidth: 0,
    },
    rowInnerForm: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
      minWidth: 0,
    },
    cellRank: {
      width: spacious ? 24 : 22,
      flexShrink: 0,
      alignItems: 'flex-start',
    },
    rankText: {
      fontSize: rankFs,
      fontWeight: '600',
      color: theme.gray[700],
    },
    cellTeam: {
      flex: spacious ? 4.6 : comfortable ? 4.7 : 4.8,
      minWidth: 0,
      flexDirection: 'row',
      alignItems: 'center',
      paddingRight: spacious ? 8 : comfortable ? 6 : 4,
    },
    cellTeamForm: {
      flex: 1,
      minWidth: 0,
      flexDirection: 'row',
      alignItems: 'center',
      paddingRight: spacious ? 8 : comfortable ? 6 : 4,
    },
    teamKitColumn: {
      width: spacious ? 24 : comfortable ? 23 : 22,
      marginRight: spacious ? 6 : 5,
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    teamName: {
      flex: 1,
      minWidth: 0,
      fontSize: teamFs,
      fontWeight: '600',
      color: theme.black,
      lineHeight: spacious ? 18 : comfortable ? 16 : 15,
    },
    cellStatSym: {
      flex: 1,
      minWidth: spacious ? 24 : 20,
      alignItems: 'flex-start',
      justifyContent: 'center',
    },
    cellStatSymText: {
      fontSize: cellFs,
      fontWeight: '500',
      color: theme.gray[700],
      textAlign: 'left',
      width: '100%',
    },
    cellPts: {
      flex: 1,
      minWidth: spacious ? 24 : 20,
      alignItems: 'flex-end',
      justifyContent: 'center',
    },
    ptsText: {
      fontSize: ptsFs,
      fontWeight: '800',
      color: theme.black,
      textAlign: 'right',
      width: '100%',
    },
    cellFormFixed: {
      width: spacious ? 108 : comfortable ? 102 : 96,
      flexShrink: 0,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    formLettersRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'nowrap',
      gap: spacious ? 4 : 3,
    },
    cellPtsForm: {
      width: spacious ? 44 : 40,
      flexShrink: 0,
      alignItems: 'flex-end',
      justifyContent: 'center',
    },
    formChip: {
      width: spacious ? 20 : 19,
      height: spacious ? 20 : 19,
      borderRadius: 6,
      alignItems: 'center',
      justifyContent: 'center',
    },
    formChipW: { backgroundColor: theme.secondaryLight },
    formChipD: { backgroundColor: theme.gray[200] },
    formChipL: { backgroundColor: theme.error + '28' },
    formChipTextBase: {
      fontSize: spacious ? 11 : 10,
      lineHeight: spacious ? 13 : 12,
      fontWeight: '800',
      ...(Platform.OS === 'android' ? { includeFontPadding: false } : {}),
    },
    formChipTextW: { color: theme.primaryDark },
    formChipTextD: { color: theme.gray[700] },
    formChipTextL: { color: theme.error },
  })
}

export type LeagueStandingsTableStyles = ReturnType<typeof getLeagueStandingsTableStyles>
